import { MfaStatus } from '@shared/constants/mfa';

export type UsersTableReference = {
  id: string;
  name: string;
};

export enum AlertType {
  NEW_USER_NO_COURSE = 'NEW_USER_NO_COURSE',
  NEW_USER_NO_THERAPIST = 'NEW_USER_NO_THERAPIST',
  USER_INACTIVE = 'USER_INACTIVE',
}

export type UsersTableAlert = {
  id: string;
  alertType: AlertType;
};

export type UsersTableRow = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone?: string | null;
  age?: number | null;
  businessUnits: UsersTableReference[];
  accountStatus?: 'ACTIVE' | 'INACTIVE' | 'INVITE_PENDING' | null;
  mfaStatus?: MfaStatus | null;
  mentors: UsersTableReference[];
  course?: UsersTableReference | null;
  skill?: UsersTableReference | null;
  lastPracticedAt?: string | null;
  alerts: UsersTableAlert[];
};

export type UsersTableOptions = {
  businessUnits: UsersTableReference[];
  mentors: UsersTableReference[];
};